import React from 'react';
import InputBase from '@material-ui/core/InputBase';

// Answer field of the exercise: >= 16px (no automatic zoom on iOS), no autocorrect / autocapitalize / spellcheck,
// value sent exactly as typed. `inputMode` / `maxLength` come from the convention parameters.
const TextAnswerInput = ({ id, value, onChange, disabled, inputMode, maxLength, describedBy }) => (
    <InputBase
        id={id}
        className="hia-ack-input"
        value={value}
        disabled={disabled}
        onChange={(event) => onChange(event.target.value)}
        inputProps={{
            'data-testid': 'answer-input',
            autoComplete: 'off',
            autoCorrect: 'off',
            autoCapitalize: 'none',
            spellCheck: false,
            inputMode,
            maxLength,
            'aria-describedby': describedBy,
            style: { fontSize: 16 },
        }}
    />
);

export default TextAnswerInput;
